import React from 'react';
import History from './History';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import { getFullPermissions } from 'reducers/PermissionsReducer';
import NoPermissionRedirect from 'components/NoPermissionRedirect';

function EventsSearch() {
  const permissions = getFullPermissions('cad', 'Events', 'any');
  if (!permissions.Read) return <NoPermissionRedirect />;
  return (
    <SearchMenu>
      <FilterConsumer>
        {({ agencies, isAllAgencies }) => (
          <History filter={agencies} isAllAgencies={isAllAgencies} />
        )}
      </FilterConsumer>
    </SearchMenu>
  );
}

export default EventsSearch;
